import { render, staticRenderFns } from "./AssetLabelFilters.vue?vue&type=template&id=b68e2fc8"
import script from "./AssetLabelFilters.vue?vue&type=script&lang=js"
export * from "./AssetLabelFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports